// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Stack, StackProps } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = Pick<StackProps, 'sx'>;

/**
 * A layout component that renders page content in a container.
 */
export function PageContent(props: PropsWithChildren<Props>) {
  return (
    <Stack
      width="100%"
      maxWidth="xl"
      marginLeft="auto"
      marginRight="auto"
      paddingY={{ xs: 2, sm: 3 }}
      paddingX={{ xs: 2, sm: 6 }}
      sx={props.sx}
    >
      {props.children}
    </Stack>
  );
}
